import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/lib/auth";
import { Toaster } from "sonner";
import "@/App.css";

import Login from "@/pages/Login";
import Layout from "@/pages/Layout";
import Dashboard from "@/pages/Dashboard";
import Products from "@/pages/Products";
import ProductDetail from "@/pages/ProductDetail";
import Categories from "@/pages/Categories";
import Users from "@/pages/Users";
import LowStock from "@/pages/LowStock";
import Movements from "@/pages/Movements";
import Orders from "@/pages/Orders";
import DailySales from "@/pages/DailySales";
import Analytics from "@/pages/Analytics";
import Finance from "@/pages/Finance";
import PurchaseOrders from "@/pages/PurchaseOrders";
import Vendors from "@/pages/Vendors";
import Collections from "@/pages/Collections";
import GstReport from "@/pages/GstReport";
import Attendance from "@/pages/Attendance";
import Salary from "@/pages/Salary";
import Tasks from "@/pages/Tasks";
import DtfSheets from "@/pages/DtfSheets";
import Settings from "@/pages/Settings";
import MobileSigning from "@/pages/MobileSigning";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading || user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="font-display uppercase tracking-widest text-xs">Loading…</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" richColors />
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/" element={<Protected><Layout /></Protected>}>
            <Route index element={<Dashboard />} />
            <Route path="products" element={<Products />} />
            <Route path="products/:id" element={<ProductDetail />} />
            <Route path="categories" element={<Categories />} />
            <Route path="users" element={<Users />} />
            <Route path="low-stock" element={<LowStock />} />
            <Route path="movements" element={<Movements />} />
            <Route path="orders" element={<Orders />} />
            <Route path="daily-sales" element={<DailySales />} />
            <Route path="analytics" element={<Analytics />} />
            <Route path="finance" element={<Finance />} />
            <Route path="purchase-orders" element={<PurchaseOrders />} />
            <Route path="vendors" element={<Vendors />} />
            <Route path="collections" element={<Collections />} />
            <Route path="gst-report" element={<GstReport />} />
            <Route path="attendance" element={<Attendance />} />
            <Route path="salary" element={<Salary />} />
            <Route path="tasks" element={<Tasks />} />
            <Route path="dtf-sheets" element={<DtfSheets />} />
            <Route path="settings" element={<Settings />} />
            <Route path="mobile-signing" element={<MobileSigning />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
